import { exportToExcel } from "../utils/exportToExcel";
import { transformPayrollData } from "./helpers/transformPayrollData";

const ExportPayroll = ({ data }) => {
  const handleDownload = () => {
    const formattedData = transformPayrollData(data);
    exportToExcel(formattedData, "Payroll_Report");
  };

  return (
    <button
      onClick={handleDownload}
      className="bg-green-600 hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white px-6 py-2.5 rounded-lg font-medium transition-colors duration-200 flex items-center gap-2"
    >
      Export Data
    </button>
  );
};

export default ExportPayroll;
